export const formatTwoDigitValues = (value: number): string => {
  if (value) {
    return value < 10 ? `0${value}` : value.toString();
  }
};
